export default "__VITE_ASSET__Cpj6hwNO__"